module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-18.c2ad3130.png";